/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/**
 * Locals
*/

/**
 * 
 */
function MakeResourcesName(name) {
  if (name[name.length-1] === 'y') {
    name = name.slice(0, name.length-1) + 'ie';
  }

  return name.toLowerCase() + 's';
}

/**
 * Exports
*/

/**
 * 
 */
export function ResourcesProvider(props) {
  /** States **/
  
  const [ resources, setResources ] = useState([]);

  /** Constants **/

  const services = {
    index: props.services[`Index${ props.name }Service`],
    show: props.services[`Show${ props.name }Service`],
    store: props.services[`Store${ props.name }Service`],
    update: props.services[`Update${ props.name }Service`],
    destroy: props.services[`Destroy${ props.name }Service`]
  };
  
  /** Side-Effects **/
  
  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/

  /**
   * 
   */
  const handleMount = () => {
    services.index()
      .then(response => setResources(response.data))
    ;
  };

  /**
   * 
   */
  const handleFind = (request) => {
    return resources.find(resource => resource.id === request.id);
  };

  /**
   * 
   */
  const handleShow = (request) => {
    return services.show(request);
  };

  /**
   * 
   */
  const handleStore = (data) => {
    return new Promise((resolve, reject) => {
      services.store(data)
        .then(response => {
          setResources([ ...resources, response.data ]);
          resolve(response);
        })
        .catch(reject)
      ;
    });
  };

  /**
   * 
   */
  const handleUpdate = (resource, data) => {
    return new Promise((resolve, reject) => {
      services.update(resource, data)
        .then(response => {
          
          resolve();
        })
        .catch(reject)
      ;
    });
  };

  /** Builders **/

  /**
   * 
   */
  const buildContextValue = () => ({
    [ MakeResourcesName(props.name) ]: resources,
    find: handleFind,
    show: handleShow,
    store: handleStore,
    update: handleUpdate
  });
  
  /** Output **/

  return (
    <props.context.Provider value={ buildContextValue() }>
      { props.children }
    </props.context.Provider>
  );
}

ResourcesProvider.propTypes = {
  name: PropTypes.string.isRequired,
  context: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired
};